import { render, staticRenderFns } from "./PaymentSummary.vue?vue&type=template&id=b336b2dc&scoped=true"
import script from "./PaymentSummary.vue?vue&type=script&lang=js"
export * from "./PaymentSummary.vue?vue&type=script&lang=js"
import style0 from "./PaymentSummary.vue?vue&type=style&index=0&id=b336b2dc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b336b2dc",
  null
  
)

export default component.exports